import React from 'react'
import { BtCurrencyInput } from '@linqpal/components/src/ui'
import { observer } from 'mobx-react'
import { useEditorModel } from '../../useEditorModel'
import { useTranslation } from 'react-i18next'
import { Spacer } from '../../../../../ui/atoms'

function validate(value) {
  return !!value
}

function Revenue(props) {
  const { t } = useTranslation('application')
  const { doc, group, item, onValueUpdate, decidingQuestion, review } = props
  const model = useEditorModel(doc, group, item, onValueUpdate, '', validate)

  const handleChange = (value: string) => {
    model.setValue('value', value)
  }

  return (
    <>
      <Spacer height={review ? 16 : 18} />
      <BtCurrencyInput
        size="large"
        label={t('Finance.RevenueLabel')}
        value={model.value}
        disabled={decidingQuestion}
        onChangeText={handleChange}
        testID={'finance_revenue'}
      />
    </>
  )
}

export default {
  title: 'Finance.AnnualRevenue',
  canSkip: false,
  component: observer(Revenue),
  decidingQuestion: true,
}
